module.exports = __webpack_public_path__ + "assets/img/Integrity_badge_Light_FI.f28baade.png";